import config from "v2/ui/components/SubsidySection/config";

export default function SubsidySection({
  benefitModel,
  country,
}: {
  benefitModel;
  country;
}) {
  const configData = config(benefitModel, country);

  return configData[country] || <></>;
}
